import React from 'react'
import axios from "axios";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import NavFormProfile from './NavFormProfile';
import AdminNavFormProfile from './AdminNavFormProfile';


import Path from "./config";
class IncomeInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sbg_job_business_info: "",
            sbg_company_name_address: "",
            sbg_yearly_income: "",
            NavMenu: false,
            apekshaLength: '0'
        }

    }

    componentDidMount() {

        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("userId")
        })

        if (localStorage.getItem("admin") === "Admin") {
            this.setState({
                NavMenu: true
            })
        }

        axios.get(Path + 'Suchi_bride_groom_incomeinfo.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                response = response.data;

                this.setState({
                    sbg_job_business_info: response.sbg_job_business_info,
                    sbg_company_name_address: response.sbg_company_name_address,
                    apekshaLength: response.sbg_company_name_address.length,
                    sbg_yearly_income: response.sbg_yearly_income,
                })
            }.bind(this))
    }
    busnameHandler = (e) => {
        document.getElementById("sbg_job_business_info").style.borderColor = "";
        let data = e.target.value;
        if (data.length > 100) {

        } else {
            this.setState
                ({ sbg_job_business_info: e.target.value })
        }

    }




    busaddHandler = (e) => {

        document.getElementById("sbg_company_name_address").style.borderColor = "";


        let data = e.target.value;
        if (data.length > 100) {

        } else {
            this.setState
                ({ sbg_company_name_address: e.target.value })
        }



    }

    incomeHandler = (e) => {
        document.getElementById("sbg_yearly_income").style.borderColor = "";
        let data = e.target.value;
        if (data.length > 10) {

        } else {
            this.setState({ sbg_yearly_income: e.target.value });
        }
    }

    submitClick = (e) => {
        e.preventDefault();

        let typee = "income";
        let tempStr = "sbg_job_business_info=" + this.state.sbg_job_business_info +
            "&sbg_company_name_address=" + this.state.sbg_company_name_address +
            "&sbg_yearly_income=" + this.state.sbg_yearly_income +
            "&sbg_id=" + this.state.userId +
            "&type=" + typee


        //console.log(tempStr)

        axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
            .then(function (response) {
                if (response.data.status === "updated") {

                    if (this.state.admin === "Admin") {
                        this.props.history.push(`/AdminProfile/FamilyInfo`);
                    }
                    else {
                        this.props.history.push(`/FormProfile/FamilyInfo`);
                    }

                }
                //alert("Updated Successfully");

            }.bind(this))

    }


    render() {
        return (
            <>
                {this.state.NavMenu ? <AdminNavFormProfile /> : <NavFormProfile />}
                <div className="m-5 pt-3" >
                    <form className="row g-3">
                        <div className="col-md-8">
                            <label for="inputEmail4" className="form-label">कंपनी/व्यवसाय चे नाव   </label>
                            <ReactTransliterate value={this.state.sbg_job_business_info} onChange={this.busnameHandler} className="form-control" id="sbg_job_business_info" placeholder="कृपया आपल्या कंपनीचे किंवा व्यवसायाचे नाव  व्यवस्थित लिहावा" />
                        </div>
                        <div className="col-md-8">
                            <label for="inputEmail4" className="form-label"> पत्ता  </label>
                            <ReactTransliterate renderComponent={(props) => <textarea {...props} />} value={this.state.sbg_company_name_address} onChange={this.busaddHandler} className="form-control" id="sbg_company_name_address" placeholder="कृपया आपल्या कंपनीचे किंवा व्यवसायाचे  पत्ता व्यवस्थित लिहावा" />

                        </div>
                        <div className="col-md-8">
                            <label for="inputEmail4" className="form-label">वार्षिक उत्पन्न (कृपया वार्षिक उत्पन्न भारतीय चलनात भरावे) </label>
                            <input type="number" value={this.state.sbg_yearly_income} onChange={this.incomeHandler} className="form-control" id="sbg_yearly_income" />
                        </div>

                        <div className="col-12">
                            <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}>Save & Next ▶️</button>
                        </div>
                    </form>
                </div>
            </>
        )
    }
}

export default IncomeInfo
